import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCircle = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 17,
	fill: "none",
	viewBox: "0 0 16 17",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#6BBC88",
		d: "M8 1.5C4.136 1.5 1 4.636 1 8.5C1 12.364 4.136 15.5 8 15.5C11.864 15.5 15 12.364 15 8.5C15 4.636 11.864 1.5 8 1.5ZM6.103 11.503L3.59 8.99C3.317 8.717 3.317 8.276 3.59 8.003C3.863 7.73 4.304 7.73 4.577 8.003L6.6 10.019L11.416 5.203C11.689 4.93 12.13 4.93 12.403 5.203C12.676 5.476 12.676 5.917 12.403 6.19L7.09 11.503C6.824 11.776 6.376 11.776 6.103 11.503Z"
	})
});
const ForwardRef = forwardRef(SvgCheckCircle);
export default ForwardRef;
